module.exports = __webpack_public_path__ + "img/package-leaf.0b5d32b5.svg";